<template>
  <b-modal :id="id" size="lg"
           ok-title="Закрыть" :ok-only="true" ok-variant="secondary">

    <template slot="modal-title">
      Заказ #{{ order.id }}
      <order-status :status="order.status"></order-status>
    </template>

    <div class="row mb-3">
      <div class="col">
        <h4>Документы</h4>
        <a :href="order.docs_dir_link" v-if="order.docs_dir_link" target="_blank">{{ order.docs_dir_link }}</a>
        <span v-else>Ссылка на папку с документами не задана.</span>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h4>Состав</h4>
        <table class="table table-sm table-borderless table-striped">
          <thead>
          <tr>
            <th width="450">Код</th>
            <th class="fit">Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="set in [...order.sets, ...order.custom_items]" :key="set.code">
            <td>{{ set.code }}</td>
            <td>{{ set.quantity }}</td>
            <td>{{ set.price | currency }}&nbsp;₽</td>
            <td>{{ set.price * set.quantity | currency }}&nbsp;₽</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <!--<td></td>-->
            <td>Итого:</td>
            <td><b>{{
                order.sets.reduce((sum, current) => sum + current.price * current.quantity, 0) +
                order.custom_items.reduce((sum, current) => sum + current.price * current.quantity, 0) | currency
              }}&nbsp;₽</b></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h4>Компания и контакт</h4>
        <table class="table table-sm table-hover table-borderless table-striped">
          <tbody>
          <tr>
            <td style="width: 110px">Компания</td>
            <td>{{ order.company.name }}</td>
          </tr>
          <tr>
            <td>Город</td>
            <td>{{ order.company.city }}</td>
          </tr>
          <tr>
            <td>Имя</td>
            <td>{{ order.person.name }}</td>
          </tr>
          <tr>
            <td>Должность</td>
            <td>{{ order.person.position }}</td>
          </tr>
          <tr>
            <td>Телефон</td>
            <td>{{ order.person.phone }}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{{ order.person.email }}</td>
          </tr>
          </tbody>
        </table>

        <h4>Прочее</h4>
        <table class="table table-sm table-hover table-borderless table-striped">
          <tbody>
          <tr>
            <td style="width: 110px">Договор</td>
            <td> {{ order.contract_num }} <span v-if="order.contract_date">от &nbsp;{{ order.contract_date }}</span>
            </td>
          </tr>
          <tr>
            <td>Срок поставки</td>
            <td>{{ order.deadline_date }}</td>
          </tr>
          <tr>
            <td>Установка</td>
            <td>
              <span v-if="order.install">Да</span>
              <span v-else>Нет</span>
            </td>
          </tr>
          <tr>
            <td>Адрес доставки</td>
            <td>{{ order.delivery_address }}</td>
          </tr>
<!--          <tr>-->
<!--            <td>Трекинг код</td>-->
<!--            <td>{{ order.tracking_code }}</td>-->
<!--          </tr>-->
          </tbody>
        </table>
      </div>
    </div>
    <h4>Комментарии</h4>
    <comments :comments="order.comments"></comments>
  </b-modal>
</template>

<script>

import OrderStatus from '~/Components/Order/OrderStatus'
import Comments from '~/Components/Comment/Comments'

export default {
  components: {
    OrderStatus,
    Comments
  },
  props: {
    id: {
      type: String,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
